var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeposit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 34,
    viewBox: "0 0 33 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.263306,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "#13B440"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2321 20.9669C20.2321 20.9667 20.2321 20.9665 20.2321 20.9663L20.2241 17.254C20.2235 16.9759 20.022 16.751 19.7738 16.7517C19.5258 16.7523 19.3251 16.9783 19.3257 17.2564L19.3311 19.7488L12.6044 12.2077C12.429 12.011 12.1446 12.011 11.9692 12.2077C11.7938 12.4044 11.7938 12.7232 11.9692 12.9199L18.6958 20.4609L16.4727 20.4549C16.2246 20.4543 16.023 20.6792 16.0224 20.9573C16.0218 21.2355 16.2225 21.4614 16.4706 21.4621L19.7819 21.4711C19.7821 21.4711 19.7823 21.471 19.7825 21.4711C20.031 21.4713 20.2324 21.2447 20.2321 20.9669Z",
    fill: "white",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeposit);
export default __webpack_public_path__ + "static/media/deposit.6b0665c1.svg";
export { ForwardRef as ReactComponent };